/* global window */
import { useState, useEffect } from 'react';

export function useMedia(mediaString: string): boolean {
    const [ isMatch, setIsMatch ] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(mediaString);
        const onChange = () => setIsMatch(Boolean(media.matches));

        if (! media) return;

        if (media.addEventListener) {
            media.addEventListener('change', onChange);
        } else {
            media.addListener(onChange);
        }
        onChange();

        return () => {
            if (media.removeEventListener) {
                media.removeEventListener('change', onChange);
            } else {
                media.removeListener(onChange);
            }
        };
    }, [ ]);

    return isMatch;
}
